import { createContext, useContext } from "react";
import { GlobalNavProps } from "../types";
import { noop } from "@react-hookz/web/cjs/util/const";

export type GlobalNavContextType = Omit<GlobalNavProps, "className">;

const GlobalNavContext = createContext<GlobalNavContextType>({
  headers: [],
  dropdownMenus: [],
  isSignedIn: false,
  onSignInClick: noop,
  profileMenu: { swooshHandle: "", userImage: "", links: [] },
  pageClickedEvent: noop,
  LinkComponent: undefined,
});

GlobalNavContext.displayName = "GlobalNavContext";

type GlobalNavProviderProps = React.PropsWithChildren<GlobalNavContextType>;

export const GlobalNavProvider: React.FC<GlobalNavProviderProps> = ({
  children,
  ...props
}) => {
  return (
    <GlobalNavContext.Provider
      value={{
        ...props,
      }}
    >
      {children}
    </GlobalNavContext.Provider>
  );
};

export const useGlobalNavContext = () => {
  return useContext(GlobalNavContext);
};
